import { createReducer } from 'redux-act';
import { closePopup, togglePopup, setImage } from './actions';

export default createReducer({
  [closePopup]: state => ({ ...state, isPopupOpen: false }),
  [togglePopup]: state => ({ ...state, isPopupOpen: !state.isPopupOpen }),
  [setImage]: (state, image) => ({ ...state, image })
});
